<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.8211 4.21967C12.114 4.51256 12.114 4.98744 11.8211 5.28033L6.56066 10.5407H10.7604C11.1746 10.5407 11.5104 10.8765 11.5104 11.2907C11.5104 11.705 11.1746 12.0407 10.7604 12.0407H4.75C4.33579 12.0407 4 11.705 4 11.2907V5.28033C4 4.86612 4.33579 4.53033 4.75 4.53033C5.16421 4.53033 5.5 4.86612 5.5 5.28033V9.48008L10.7604 4.21967C11.0533 3.92678 11.5282 3.92678 11.8211 4.21967Z"
    fill="currentColor"
  />
</svg>
